module.exports = __webpack_public_path__ + "img/logo-dark.50fc60d6.png";